import { env } from '../env.js';
import { apiOriginOf } from './return-to.js';

/**
 * Origin admin-api — единственный, на который может указывать `?returnTo=`
 * (закрытая документация MCP, `/docs/mcp`), и origin ссылки «Документация MCP»
 * в меню. Вычисляется в одном месте: `app.tsx`, `app-shell.tsx` и `login.tsx`
 * берут его отсюда (`login.tsx` не может импортировать `app.tsx` — цикл).
 */
export const API_ORIGIN: string = apiOriginOf(env.VITE_ADMIN_API_URL, window.location.origin);
